const COLOR = {
    deepBlue: "#000F43",
    grey: "#3B3E44",
    skyBlue: "#84AAE3",
    lightBlue: "#EAF2F9",
    white: "#FFFFFF",
}

export default COLOR;